import { render, staticRenderFns } from "./viewDis.vue?vue&type=template&id=156e12b4"
import script from "./viewDis.vue?vue&type=script&lang=js"
export * from "./viewDis.vue?vue&type=script&lang=js"
import style0 from "./viewDis.vue?vue&type=style&index=0&id=156e12b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports